<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Visit Invoices</h3>
          <v-card>
            <v-card-title class="pa-1">
              <v-btn small icon fab @click="goTo('/clients/' + client.id + '/visits/' + visit.id)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn small outlined color="orange" @click="addNew = !addNew">Create Invoice</v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="invoices" :headers="headers" dense no-data-text="No invoices found.">
                <template v-slot:[`item.date`]="{ item }">
                  <inertia-link :href="'/invoices/' + item.id">{{ item.date ?  moment(item.date).format('l') : moment(item.created_at).format('l') }}</inertia-link>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  {{ item.amount.format() }}
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <mk-dialog v-model="addNew">
        <template #title>Create Invoice</template>
        <v-card>
          <v-sheet class="pr-10">
            <!--  -->
          </v-sheet>
          <v-card-text>
            <form @submit.prevent="createInvoice(invoice)">
              <v-text-field label="Amount" type="number" v-model="invoice.net" step="0.01" :min="invoices.length > 0 ? '' : 0" required="required"></v-text-field>
              <v-text-field :label="'Date (default: ' + moment().format('ll') + ')'" v-model="invoice.date" type="date"></v-text-field>
              <v-btn small type="submit" color="primary" class="pull-right" :loading="invoice.processing">Next</v-btn><br>
            </form>
          </v-card-text>
        </v-card>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')

  export default {
    name: 'VisitInvoices',
    layout,
    props: [
      'client', 'visit', 'store_link'
    ],
    components: {
      MkDialog,
    },
    metaInfo () {
      return {
        title: 'Visit Invoices',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        headers: [
          {
            text: 'Date', value: 'date'
          },
          {
            text: 'Amount', value: 'amount', align: 'right'
          },
          {
            text: 'Status', value: 'status',
          },
          {
            text: '', value: 'check'
          }
        ],
        addNew: false,
        invoice: this.$inertia.form({
          net: 0,
        }),
      }
    },
    methods: {
      createInvoice (invoice) {
        this.invoice.post(this.store_link, {
          onSuccess: () => {
            swal({ title: 'Saved', type: 'success', timer: 5000 })
            this.addNew = false
          }
        })
      },
    },
    computed: {
      invoices () {
        return this.visit.invoices
      }
    },
  }
</script>
